// Auto generated file, do not manually modify!
// com.hotpads.leasing.api.web.v1.tenant.LeasingTenantWebApiHandler

import type { QueryOptions, UseQueryOptions } from '@zg-rentals/react-query5';
import { useQuery } from '@zg-rentals/react-query5';
import { tsClientOptions } from '@zg-rentals/react-query5';
import type { Client } from '@zg-rentals/http-client';
import {
  LeasingTenantWebApiHandler_getPaginatedLeasesForTenant,
  LeasingTenantWebApiHandler_getPaginatedLeasesForTenant_Path,
  LeasingTenantWebApiHandler_getTenantInfo,
  LeasingTenantWebApiHandler_getTenantInfo_Path,
} from '@zg-rentals/ts-leasing-client';

import type {
  GetPaginatedLeasesForTenantWebApiResponseDto,
  GetTenantInfoWebApiResponseDto,
} from '@zg-rentals/ts-leasing-client';

interface GetPaginatedLeasesForTenantParams {
  numResults: number;
  offset: number;
}

export type LeasingTenantWebApiHandler_getPaginatedLeasesForTenant_Options = UseQueryOptions<
  GetPaginatedLeasesForTenantWebApiResponseDto,
  unknown,
  GetPaginatedLeasesForTenantWebApiResponseDto,
  readonly [string, GetPaginatedLeasesForTenantParams]
>;

const LeasingTenantWebApiHandler_getPaginatedLeasesForTenant_GetKey = (getParams: GetPaginatedLeasesForTenantParams) =>
  [LeasingTenantWebApiHandler_getPaginatedLeasesForTenant_Path, getParams] as const;

export const LeasingTenantWebApiHandler_getPaginatedLeasesForTenant_queryOptions = (
  getParams: GetPaginatedLeasesForTenantParams,
  { httpClient }: { httpClient?: Client } = {},
) =>
  ({
    ...tsClientOptions.queryOptions,
    queryKey: LeasingTenantWebApiHandler_getPaginatedLeasesForTenant_GetKey(getParams),
    queryFn: () => LeasingTenantWebApiHandler_getPaginatedLeasesForTenant(getParams, httpClient),
  }) as const satisfies QueryOptions;

/**
 * get paginated leases for tenant
 */
export const useLeasingTenantWebApiHandler_getPaginatedLeasesForTenant = (
  getParams: GetPaginatedLeasesForTenantParams,
  {
    httpClient,
    ...options
  }: Omit<LeasingTenantWebApiHandler_getPaginatedLeasesForTenant_Options, 'queryFn' | 'queryKey'> & {
    httpClient?: Client;
  } = {},
) => {
  return useQuery({
    ...LeasingTenantWebApiHandler_getPaginatedLeasesForTenant_queryOptions(getParams, { httpClient }),
    ...options,
  });
};
useLeasingTenantWebApiHandler_getPaginatedLeasesForTenant.getKey =
  LeasingTenantWebApiHandler_getPaginatedLeasesForTenant_GetKey;

export type LeasingTenantWebApiHandler_getTenantInfo_Options = UseQueryOptions<
  GetTenantInfoWebApiResponseDto,
  unknown,
  GetTenantInfoWebApiResponseDto,
  readonly [string]
>;

const LeasingTenantWebApiHandler_getTenantInfo_GetKey = () => [LeasingTenantWebApiHandler_getTenantInfo_Path] as const;

export const LeasingTenantWebApiHandler_getTenantInfo_queryOptions = ({ httpClient }: { httpClient?: Client } = {}) =>
  ({
    ...tsClientOptions.queryOptions,
    queryKey: LeasingTenantWebApiHandler_getTenantInfo_GetKey(),
    queryFn: () => LeasingTenantWebApiHandler_getTenantInfo(httpClient),
  }) as const satisfies QueryOptions;

/**
 * get tenant information
 */
export const useLeasingTenantWebApiHandler_getTenantInfo = ({
  httpClient,
  ...options
}: Omit<LeasingTenantWebApiHandler_getTenantInfo_Options, 'queryFn' | 'queryKey'> & { httpClient?: Client } = {}) => {
  return useQuery({
    ...LeasingTenantWebApiHandler_getTenantInfo_queryOptions({ httpClient }),
    ...options,
  });
};
useLeasingTenantWebApiHandler_getTenantInfo.getKey = LeasingTenantWebApiHandler_getTenantInfo_GetKey;
